import { pluralize } from '@/shared/utils/strings';

export const getCharacterLimitState = (text: string, maxlength: number) => {
    const limit = Math.max(maxlength, 0);

    if (!limit) {
        return null;
    }

    const remaining = limit - text.length;
    const excess = Math.max(-remaining, 0);
    const error = excess
        ? `${excess} ${pluralize(excess, { one: 'character', other: 'characters' })} over the ${limit} character limit`
        : '';

    return {
        remaining,
        excess,
        error,
    };
};
